import React from "react";
import styles from "./SidePanelHeader.module.css";

export default function SidePanelHeader({ children }) {
	return <div className={styles.panelHeader}>{children}</div>;
}
